import { FC } from 'react';
import ReactPasswordStrength from 'react-password-strength/dist/universal';

import { i18n as I18n } from '../../../utils/i18n';

interface Props {
  value: string;
  onChange: (value: string) => void;
}

const PasswordWithStrengthIndicator: FC<Props> = ({
  value = '',
  onChange: setValue = () => {},
  ...props
}) => {
  // FIXME: Find an alternative to this library. The defaultValue prop is just
  // the initial value and doesn't make it a controlled component.
  return (
    <ReactPasswordStrength
      className="field__input"
      minLength={10}
      minScore={4}
      tooShortWord={I18n.t('registration.user_details.password.too_short')}
      scoreWords={[
        I18n.t('registration.user_details.password.weak'),
        I18n.t('registration.user_details.password.okay'),
        I18n.t('registration.user_details.password.good'),
        I18n.t('registration.user_details.password.strong'),
        I18n.t('registration.user_details.password.stronger'),
      ]}
      changeCallback={({ password }) => setValue(password)}
      defaultValue={value}
      inputProps={{
        name: 'password',
        autoComplete: 'off',
        className: 'form-control',
        placeholder: I18n.t('registration.user_details.fields.password.label'),
        ...props,
      }}
    />
  );
};

export default PasswordWithStrengthIndicator;
